// extracted by mini-css-extract-plugin
export const root = "about-team-module--root--1U28W";
export const heading = "about-team-module--heading--13utq";